import Resources from './resources';

import { MatSnackBarConfig } from '@angular/material/snack-bar';
import * as CryptoJS from 'crypto-js';

import { SessionStorageService } from '../services/session.service';

export default class Utils {

  constructor(private sessionService: SessionStorageService) { }

  // Date format - YYYY-MM-DD
  static formatDate(date: any) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  }

  // Remove some session storage key based on scenario 
  static removeSessionStorageValuesForLoggedInUser(): void {
    sessionStorage.removeItem(Resources.SessionStorageKeys.AmountData);
    sessionStorage.removeItem(Resources.SessionStorageKeys.ContractEndDate);
    sessionStorage.removeItem(Resources.SessionStorageKeys.CSInfo);
    sessionStorage.removeItem(Resources.SessionStorageKeys.SiteId);
    sessionStorage.removeItem(Resources.SessionStorageKeys.RollOverObj);
    sessionStorage.removeItem(Resources.SessionStorageKeys.FuelType);
    sessionStorage.removeItem(Resources.SessionStorageKeys.SelectedSite);
    sessionStorage.removeItem(Resources.SessionStorageKeys.SelectedAddress);
    sessionStorage.removeItem(Resources.SessionStorageKeys.MeterInfo);
    sessionStorage.removeItem(Resources.SessionStorageKeys.MeterDetails);
    sessionStorage.removeItem(Resources.SessionStorageKeys.UploadBillData);
    sessionStorage.removeItem(Resources.SessionStorageKeys.AddressSelect);
    sessionStorage.removeItem(Resources.SessionStorageKeys.SupplierToSwitch);
    sessionStorage.removeItem(Resources.SessionStorageKeys.DashboardSummary);
    sessionStorage.removeItem(Resources.SessionStorageKeys.QuoteCurrentSupply);
    sessionStorage.removeItem(Resources.SessionStorageKeys.QuoteSummary);
    sessionStorage.removeItem(Resources.SessionStorageKeys.SpendId);
    sessionStorage.removeItem(Resources.SessionStorageKeys.Bank);

    sessionStorage.removeItem(Resources.SessionStorageKeys.selectedCompanyType);
    sessionStorage.removeItem(Resources.SessionStorageKeys.Company);
    // localStorage.clear();
  }

  static showSnackBar(snackbar, msg, duration) {
    let config = new MatSnackBarConfig();
    config.horizontalPosition = 'center';
    config.verticalPosition = 'top';
    config.duration = duration;
    config.panelClass = ['snackbar']
    snackbar.open(msg, 'ERROR', config);
  }

  static showSuccessSnackBar(snackbar, msg, duration) {
    let config = new MatSnackBarConfig();
    config.horizontalPosition = 'center';
    config.verticalPosition = 'top';
    config.duration = duration;
    config.panelClass = ['snackbar']
    snackbar.open(msg, 'SUCCESS', config);
  }

  static removeQuote(str: any) {
    if (!!str)
      return str.replace(/['"]+/g, '');
    else
      return '';
  }

  // Join address
  static joinAddress(address1?, address2?, address3?, address4?): string {
    const tempArr = [];
    if (!!address1) tempArr.push(address1);
    if (!!address2) tempArr.push(' ' + address2);
    if (!!address3) tempArr.push(' ' + address3);
    if (!!address4) tempArr.push(' ' + address4);

    return tempArr.toString();
  }

  // Join Address history
  static joinAddressHistory(buildingNumber?, buildingName?, street?, town?, postcode?): string {
    const tempArr = [];
    if (!!buildingNumber) (typeof buildingNumber === 'number') ? buildingNumber : tempArr.push((buildingNumber)?.toLowerCase()?.trim());
    if (!!buildingName) tempArr.push((buildingName)?.toLowerCase()?.trim());
    if (!!street) tempArr.push((street)?.toLowerCase()?.trim());
    if (!!town) tempArr.push((town)?.toLowerCase()?.trim());
    if (!!postcode) tempArr.push((postcode)?.toLowerCase()?.trim());

    return tempArr.toString().replace(/,/g, ' ');
  }

  // Generic method to manipulate company raw data into mapper and store into memory.
  static genericForCompanyDetails(company: any, companyType: string): any | void {
    // this.spinner.hide();
    let companyDetails = company;
    if (!company?.address) {
      companyDetails.address = {
        premises: !!company?.address1 ? company?.address1 : '',
        addressLine1: !!company?.address2 ? company?.address2 : '',
        locality: !!company?.address3 ? company?.address3 : '',
        region: !!company?.address4 ? company?.address4 : '',
        postalCode: !!company?.postCode ? company?.postCode : ''
      }
    }
    // For Charity
    if (companyType === 'Charity') {
      companyDetails.companyNumber = company?.regCharityNumber;
      companyDetails.regCharityNumber = company?.regCharityNumber;
    } else {
      companyDetails.companyNumber = company?.companyNumber;
    }

    companyDetails.title = company?.title;
    companyDetails.companyName = !!company?.title ? company?.title : (company?.companyName).trim();

    // Store into session
    sessionStorage.setItem(Resources.SessionStorageKeys.Company, JSON.stringify(companyDetails));
    // If postcode not updated
    if (!companyDetails?.address?.postalCode) {
      return {
        isCompanyAddress: false,
        company: {
          businessName: company?.title,
          businessNumber: company?.companyNumber,
          businessAddress: {
            buildingNumber: company?.address?.premises,
            buildingName: company?.address?.addressLine1,
            street: company?.address?.locality,
            city: company?.address?.region,
            postcode: company?.address?.postcode,
          }
        }
      };
    } else {
      return {
        isCompanyAddress: true,
        company: companyDetails
      };
      // this.companyFormGroup.reset('');
    }
  }

  static gtmEvent(eventType: string, eventAction: string) {
    const gtmTag = {
      event: eventAction,
      eventAction: eventType,
    };
    return gtmTag;
  }

  static decode(cipherText): any {
    const decode = CryptoJS.AES.decrypt(cipherText, Resources.SessionKey.decryptKey).toString(CryptoJS.enc.Utf8);
    return decode;
  }

  static encryptVersion() {
    var encryptedVersion = CryptoJS.AES.encrypt('v0.01', 'SEC@BUSINESS').toString();
    return encryptedVersion;
  }
}
